var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"lg","spinner-variant":"customer"}})}
var staticRenderFns = []

export { render, staticRenderFns }